// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Templates from '../components/Templates';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    information: state.ui.storeInformation,
    isFetchingStoreInformation: state.ui.isFetchingStoreInformation,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(Templates);
